// Emoji have to be drawn by a COLOUR emoji font.
//
// The admin's own stack is `'Noto Sans Arabic', 'Roboto', sans-serif` (src/config.js) and
// none of those carry emoji glyphs, so the browser was left to pick a fallback — which can
// land on a monochrome symbol font. Combined with MUI's default IconButton text colour
// (`action.active`, a 54%-opacity grey) the chat emoji picker rendered washed-out and grey.
//
// Name the colour fonts explicitly anywhere raw emoji characters are rendered.
// Shared by admin-chat and trainer-chat, which are near-copies of each other — keeping it
// in one module stops the two pickers drifting apart again.
export const EMOJI_FONT_STACK =
  '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "Twemoji Mozilla", sans-serif';

// For fields that hold BOTH normal text and emoji — the message composer and the chat
// bubbles. App fonts first so Arabic and Latin are unaffected; the colour emoji fonts sit
// at the end purely as the fallback for emoji codepoints. Without this the browser picks
// its own fallback, which rendered emoji noticeably smaller than the surrounding text.
export const TEXT_WITH_EMOJI_FONT_STACK =
  `'Noto Sans Arabic', 'Roboto', -apple-system, BlinkMacSystemFont, ${EMOJI_FONT_STACK}`;
